import { useEffect, useState } from "react";

const AdminBanners = () => {
  const [banners, setBanners] = useState([]);
  const [file, setFile] = useState(null);
  const [link, setLink] = useState("");
  const [position, setPosition] = useState("");
  const [block, setBlock] = useState("search"); // search, home, profile

  const loadBanners = () => {
    fetch(`/api/banners_api.php?block=${block}`)
      .then((res) => res.json())
      .then((data) => setBanners(data))
      .catch((err) => console.error("Fetch error:", err));
  };

  useEffect(() => {
    loadBanners();
  }, [block]);

  const handleAdd = async (e) => {
    e.preventDefault();
    if (!file) return alert("Խնդրում ենք ընտրել նկարը 📷");

    const formData = new FormData();
    formData.append("image", file);
    formData.append("link_url", link);
    formData.append("position", position);
    formData.append("banner_block", block);

    await fetch("/api/banners_api.php", {
      method: "POST",
      body: formData,
    });

    setFile(null);
    setLink("");
    setPosition("");
    loadBanners();
  };

  const handleDelete = (id) => {
    fetch(`/api/banners_api.php?id=${id}`, {
      method: "DELETE",
    }).then(() => loadBanners());
  };

  return (
    <div className="p-3 sm:p-4 md:p-6">
      <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-4 sm:mb-6">
        Կառավարել Բաներների Բլոկները
      </h2>

      {/* 🔸 Выбор блока - ТРИ КНОПКИ */}
      <div className="flex flex-col sm:flex-row gap-2 sm:gap-3 md:gap-4 my-4 sm:my-6">
        <button
          onClick={() => setBlock("search")}
          className={`px-4 sm:px-6 py-2 sm:py-3 rounded-lg transition-all font-medium text-sm sm:text-base ${
            block === "search"
              ? "bg-[#006674] text-white shadow-lg"
              : "bg-gray-200 text-gray-700 hover:bg-gray-300"
          }`}
        >
           Search էջի բլոկ
        </button>
        <button
          onClick={() => setBlock("home")}
          className={`px-4 sm:px-6 py-2 sm:py-3 rounded-lg transition-all font-medium text-sm sm:text-base ${
            block === "home"
              ? "bg-[#006674] text-white shadow-lg"
              : "bg-gray-200 text-gray-700 hover:bg-gray-300"
          }`}
        >
           Գլխավոր էջի բլոկ
        </button>
        <button
          onClick={() => setBlock("profile")}
          className={`px-4 sm:px-6 py-2 sm:py-3 rounded-lg transition-all font-medium text-sm sm:text-base ${
            block === "profile"
              ? "bg-[#006674] text-white shadow-lg"
              : "bg-gray-200 text-gray-700 hover:bg-gray-300"
          }`}
        >
           Profile էջի բլոկ
        </button>
      </div>

      {/* 🔸 Форма добавления */}
      <form onSubmit={handleAdd} className="space-y-3 sm:space-y-4 w-full bg-white p-4 sm:p-6 rounded-lg shadow-lg">
        <h3 className="text-lg sm:text-xl font-bold text-[#006674] mb-2 sm:mb-4">
          {block === "search" && " Ավելացնել բաններ Search էջի համար"}
          {block === "home" && " Ավելացնել բաններ Գլխավոր էջի համար"}
          {block === "profile" && " Ավելացնել բաններ Profile էջի համար"}
        </h3>
        
        <div className="flex flex-col gap-2">
          <label className="text-gray-700 font-medium text-sm sm:text-base" htmlFor="file">
            Բանների նկար *
          </label>
          <label
            className="bg-[#006674] text-white px-4 py-2 rounded hover:bg-[#004d58] transition-all cursor-pointer w-max text-sm sm:text-base"
            htmlFor="file"
          >
             {file ? file.name : "Կցել նկար"}
          </label>
          <input
            type="file"
            accept="image/*"
            onChange={(e) => setFile(e.target.files[0])}
            className="hidden"
            id="file"
          />
        </div>

        <div className="flex flex-col gap-2">
          <label className="text-gray-700 font-medium text-sm sm:text-base" htmlFor="link">
             Հղում *
          </label>
          <input
            type="text"
            id="link"
            placeholder="https://example.com կամ /internal-page"
            value={link}
            onChange={(e) => setLink(e.target.value)}
            className="outline-none border-2 border-gray-200 transition-all focus:border-[#006674] p-2 w-full rounded text-sm sm:text-base"
            required
          />
        </div>

        <div className="flex flex-col gap-2">
          <label className="text-gray-700 font-medium text-sm sm:text-base" htmlFor="position">
             Դիրք (1, 2, 3) *
          </label>
          <input
            type="number"
            id="position"
            placeholder="Մուտքագրեք 1, 2 կամ 3"
            value={position}
            onChange={(e) => setPosition(e.target.value)}
            className="outline-none border-2 border-gray-200 transition-all focus:border-[#006674] p-2 w-full rounded text-sm sm:text-base"
            required
            min="1"
            max="3"
          />
          <p className="text-xs sm:text-sm text-gray-500">
            {block === "search" && " Search էջում կա 3 բանների տեղ (1-ը ձախ, 2-ը և 3-ը աջ)"}
            {block === "home" && " Գլխավոր էջում կա 2 բանների տեղ (1-ին և 2-րդ դիրքեր)"}
            {block === "profile" && " Profile էջում կա 2 բանների տեղ (1-ին դիրք)"}
          </p>
        </div>

        <button
          type="submit"
          className="bg-[#006674] text-white px-4 sm:px-6 py-2 w-full sm:w-max rounded hover:bg-[#004d58] transition-all mt-2 sm:mt-4 font-medium text-sm sm:text-base"
        >
           Ավելացնել բաններ
        </button>
      </form>

      {/* 🔸 Список баннеров */}
      <div className="mt-6 sm:mt-8">
        <h3 className="text-xl sm:text-2xl font-bold text-white mb-3 sm:mb-4">
          {block === "search" && "📋 Search էջի բաններներ"}
          {block === "home" && "📋 Գլխավոր էջի բաններներ"}
          {block === "profile" && "📋 Profile էջի բաններներ"}
        </h3>
        
        {banners.length === 0 ? (
          <div className="bg-white p-3 rounded-lg text-center text-gray-500 text-sm sm:text-base">
             Այս բլոկում բաններներ չկան
          </div>
        ) : (
          <ul className="space-y-2 sm:space-y-3">
            {banners
              .sort((a, b) => Number(a.position) - Number(b.position))
              .map((b) => (
                <li
                  key={b.id}
                  className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 sm:gap-4 bg-white p-3 sm:p-4 rounded-lg shadow hover:shadow-md transition-all"
                >
                  <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 sm:gap-4 w-full sm:w-auto">
                    <img
                      src={b.image_url}
                      alt="banner"
                      className="w-full sm:w-36 h-24 object-cover rounded border border-gray-200"
                    />
                    <div className="flex flex-col gap-1">
                      <div className="flex items-center gap-2">
                        <span className="bg-[#006674] text-white px-2 py-1 rounded text-xs sm:text-sm font-bold">
                          #{b.position}
                        </span>
                        <span className="text-xs sm:text-sm text-gray-500">
                          {b.created_at && new Date(b.created_at).toLocaleDateString()}
                        </span>
                      </div>
                      <a
                        href={b.link_url}
                        className="text-blue-600 hover:underline text-xs sm:text-sm mt-1 break-all"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {b.link_url.length > 40
                          ? b.link_url.substring(0, 40) + "..."
                          : b.link_url}
                      </a>
                    </div>
                  </div>
                  <button
                    onClick={() => handleDelete(b.id)}
                    className="bg-red-500 text-white px-3 sm:px-4 py-1.5 sm:py-2 rounded hover:bg-red-600 transition-all text-sm sm:text-base w-full sm:w-auto mt-2 sm:mt-0"
                  >
                     Ջնջել
                  </button>
                </li>
              ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default AdminBanners;